import { Fragment, useEffect } from "react";
import { FormattedMessage as FM } from "react-intl";
import { useParams } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { signal } from "@preact/signals-react";

import Layout from "ext-apps/layout/Layaot";
import Folios from "./pages/Folios";
import Tra from "./pages/Tra";
import proxy from "api/proxy";
import { getStorage } from "store/local";
import FinishPage from "./pages/FinishTraPage";

const foliosPending = signal([]);
const isLoading = signal(true);
const configHotel = signal(null);
const openModalLang = signal(false);

const _FIELDS_FOLIO = [
  "room.name",
  "arrival_date",
  "departure_date",
  "nights_quantity",
  "unit_price",
  "vehicle_plate",
  "main_guest.name",
  "main_guest.code",
  "main_guest.email",
  "main_guest.phone",
  "main_guest.nationality",
  "main_guest.nationality.name",
  "main_guest.birthday",
  "main_guest.sex",
  "main_guest.mobile",
  "main_guest.type_document",
  "main_guest.id_number",
  "main_guest.customer_location.name",
  "main_guest.supplier_location.name",
  "guests.name",
  "guests.type_guest",
  "guests.type_document",
  "guests.id_number",
  "booking.channel.name",
  "booking.number",
  // "booking.environment.name",
  "booking.payments",
  "party.name",
  "product.name",
  "signature",
  "number",
];

const FIELDS_FOLIOS = [
  "main_guest.id_number",
  "room.name",
  "booking.number",
  "channel.code",
];

const Index = () => {
  const { id, request } = useParams();
  const { company } = getStorage("ctxVirtualSession");
  const fields = id ? _FIELDS_FOLIO : FIELDS_FOLIOS;
  const domain = id
    ? ["id", "=", id]
    : [
        ["signature", "=", null],
        ["check_in_user", "!=", null],
        ["check_out_user", "=", null],
      ];

  useQuery({
    queryKey: ["foliosPending", id],
    // enabled: false,
    queryFn: async () => {
      let _folios = [];
      const { data: folios, error } = await proxy.search(
        "hotel.folio",
        domain,
        fields,
      );

      if (folios) {
        _folios = folios;
      }
      foliosPending.value = _folios;
      isLoading.value = false;
    },
  });

  useEffect(() => {
    getContract();
  }, []);

  async function getContract() {
    const { data: config } = await proxy.search(
      "hotel.configuration",
      ["company", "=", company],
      ["registration_card_contract", "company.logo_link"],
    );

    if (config?.length) {
      configHotel.value = config[0];
    }
  }

  return (
    <Fragment>
      {request ? (
        <FinishPage folio={foliosPending.value} />
      ) : (
        <Layout
          title={
            id ? (
              `TRA | ${foliosPending.value[0]?.["booking."]?.number} | ${foliosPending.value[0]?.number}`
            ) : (
              <FM id="hotel_tra_register_card" />
            )
          }
          back={id ? true : false}
          openModal={openModalLang}
        >
          {id ? (
            <Tra
              folio={foliosPending.value}
              isLoading={isLoading}
              configHotel={configHotel}
            />
          ) : (
            <Folios
              folios={foliosPending.value}
              isLoading={isLoading}
              configHotel={configHotel}
              openModal={openModalLang}
            />
          )}
        </Layout>
      )}
    </Fragment>
  );
};

export default Index;
